import { render, staticRenderFns } from "./base-performance-detail.vue?vue&type=template&id=2d7238af&scoped=true"
import script from "./base-performance-detail.vue?vue&type=script&lang=ts"
export * from "./base-performance-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7238af",
  null
  
)

export default component.exports